import { IFormatter } from '../interfaces';

interface IDecimalFormatterOptions {
  decimalSeparator?: string;
  stripDecimals?: boolean;
}

const defaultOptions: IDecimalFormatterOptions = {
  decimalSeparator: ',',
  stripDecimals: false,
};

export class DecimalFormatter implements IFormatter<IDecimalFormatterOptions> {
  format(input: string | number, options?: IDecimalFormatterOptions): string {
    
    if (input == null) {
      return '';
    }

    const asNumber = typeof (input) === 'number' ? input : parseFloat(input);

    // Guards
    if (isNaN(asNumber) || !isFinite(asNumber)) {
      return input.toString();
    }

    const opts = {
      ...defaultOptions,
      ...options,
    };

    const decimals = opts.stripDecimals ? 0 : 2;
    let result = asNumber.toFixed(decimals);
    if (opts.decimalSeparator) {
      result = result.replace('.', opts.decimalSeparator);
    }

    return result;
  }

}